import { all } from 'redux-saga/effects';

// Sagas
import coreSagas from 'Core/.globals/redux/sagas';
import accountsSagas from 'Modules/accounts/.globals/redux/sagas';
import devicesSagas from 'Modules/devices/.globals/redux/sagas';
import activitiesSagas from 'Modules/activities/.globals/redux/sagas';
import rawDataSagas from 'Modules/rawData/.globals/redux/sagas';
import pmUsersSagas from 'Modules/pmUsers/.globals/redux/sagas';
import vidfleetSagas from 'Modules/vidfleet/.globals/redux/sagas';
import transactionsSagas from 'Modules/transactions/.globals/redux/sagas';
import commonModulesSagas from 'Modules/.common/.globals/sagas';
import packagesSagas from 'Modules/packages/.globals/redux/sagas';
import keysFobsSagas from 'Modules/keysFobs/.globals/redux/sagas';
import manufacturersSagas from 'Modules/manufacturers/.globals/redux/sagas';
import usersSagas from 'Modules/users/.globals/redux/sagas';
import cloudLoginPageSagas from 'Modules/loginPage/.globals/redux/sagas';
import reportsSagas from 'Modules/reports/.globals/redux/sagas';
import importP4Sagas from 'Modules/importP4/.globals/redux/sagas';
import importAccountSagas from 'Modules/importAccount/.globals/redux/sagas';
import dashboardSagas from 'Modules/dashboard/.globals/redux/sagas';
import alertTypesSagas from 'Modules/alertTypes/.globals/redux/sagas';
import scheduledActionsSagas from 'Modules/scheduledActions/.globals/redux/sagas';
import eventsSagas from 'Modules/events/.globals/redux/sagas';
import unsubscribedContactsSagas from 'Modules/unsubscribedContacts/.globals/redux/sagas';
import simProvidersSagas from 'Modules/simProviders/.globals/redux/sagas';
import simProviderAccountsSagas from 'Modules/simProviderAccounts/.globals/redux/sagas';
import smsSystemsSagas from 'Modules/smsSystems/.globals/redux/sagas';
import dealersSagas from 'Modules/dealers/.globals/redux/sagas';
import tagsSagas from 'Modules/tags/.globals/redux/sagas';
import brandsSagas from 'Modules/brands/.globals/redux/sagas';

export default function* rootSaga() {
	yield all([
		coreSagas(),
		accountsSagas(),
		activitiesSagas(),
		devicesSagas(),
		rawDataSagas(),
		pmUsersSagas(),
		vidfleetSagas(),
		transactionsSagas(),
		commonModulesSagas(),
		packagesSagas(),
		keysFobsSagas(),
		manufacturersSagas(),
		usersSagas(),
		cloudLoginPageSagas(),
		reportsSagas(),
		importP4Sagas(),
		importAccountSagas(),
		dashboardSagas(),
		alertTypesSagas(),
		scheduledActionsSagas(),
		eventsSagas(),
		unsubscribedContactsSagas(),
		simProvidersSagas(),
		simProviderAccountsSagas(),
		smsSystemsSagas(),
		dealersSagas(),
		tagsSagas(),
		brandsSagas(),
	]);
}